import React from 'react';
import prize from '../../assets/prize.webp';
import {Image} from '@/components-v2';
import {ReactComponent as Clock} from '../../assets/icon/clock.svg';
import GameContainer from './game-container';
import {KeralaListItem} from '@/pages/home/home.type';
import globalStore from '@services/global.state';
import {goTo} from '@utils';
import {CurrencyMap} from '@services/currency';

const DATE = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const cardBgStyle = {
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100% 100%',
};

const KeralaCard = ({
  v,
  isHome = true,
  isClosed = true,
}: {
  v: KeralaListItem;
  i: number;
  isHome?: boolean;
  isClosed?: boolean;
}) => {
  const cardWidth = isHome ? '9.875rem' : 'calc((100% - 0.5rem) / 2)';
  return (
    <GameContainer
      style={{
        width: cardWidth,
      }}
      onClick={() => {
        globalStore.updateAmount.next({gameType: 'Kerala'});
        goTo('GameWebView', {
          type: 'kerala',
          params: `data=${JSON.stringify(v)}`,
        });
      }}
      closed={isClosed}
      gameName={`${
        (v.lotteryType?.indexOf('BUMPER') > -1 ? 'festival' : 'weekly') +
        ' lottery'
      } ${v.issueNo}`}>
      <div
        className={`${
          isHome ? 'shrink-0' : ''
        } rounded-xl py-2 px-3 h-[6.25rem] overflow-hidden flex flex-col justify-between`}
        style={{
          ...cardBgStyle,
          backgroundImage: `url(${v.backImg})`,
        }}>
        <div>
          <p className="font-bold text-sm text-white">{v.lotteryType}</p>
          <div className="flex flex-row items-center justify-center">
            <Image
              src={prize}
              alt="prize"
              className="w-[0.75rem] h-[0.75rem] object-contain mr-1"
            />
            <p className="text-sm font-bold italic text-white">
              {CurrencyMap.default}{' '}
              {v.lotteryMoney < 100 ? v.lotteryMoney : v.lotteryMoney / 100}{' '}
              {v.lotteryMoney < 100 ? 'Lakhs' : 'Crore'}
            </p>
          </div>
        </div>
        <div>
          <div className="flex flex-row items-center justify-between">
            <p className="text-sm font-medium text-white">
              {CurrencyMap.default} {v.lotteryPrice}
            </p>
            <p className="text-sm font-medium text-white">{v.issueNo}</p>
          </div>
          <div
            className={`flex flex-row items-center ${
              isHome ? 'justify-between mt-2' : 'mt-1'
            }`}>
            <div className="flex flex-row items-center">
              <Clock />
              <p
                className={`text-xs font-medium text-white ${
                  isHome ? 'ml-1' : 'ml-2'
                }`}>
                {DATE[new Date(v.drawDate).getDay()]}
              </p>
            </div>
            <p className="text-xs font-medium text-white ml-2">{v.drawTime}</p>
          </div>
        </div>
      </div>
    </GameContainer>
  );
};

export default KeralaCard;
